import styled from "styled-components";
import Flex from "../../layout/flex";
import { tokens } from "@manifesthhqinc/ui-library";

export const CheckboxDiv = styled(Flex)`
  width: 100%;
  cursor: pointer;
  align-items: flex-start;

  p {
    cursor: inherit;
  }

  a {
    color: ${tokens.color.brand[600]};
  }
`;

export const CheckboxIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  margin-right: 12px;
  align-items: flex-start;
  justify-content: center;
  cursor: inherit;
`;
